import React, {FC, ReactNode} from 'react';
import {ThemeProvider} from 'styled-components';

import {AppContentTypesEnum} from '../../../../libs/shared/core/src/store/panels/app/commonAppPanelState';
import {useExpandedDarkTheme} from '../../../../libs/shared/ui/src/theme/expandedDarkThemeProvider';
import {lightTheme} from '../../../../libs/shared/ui/src/theme/light/lightTheme';

/*
 * Props.
 */

interface TopBarExpandedDarkThemeProviderProps {
  appContentType: AppContentTypesEnum;
  children: ReactNode;
}

/*
 * Constants.
 */

const appsSupportingDarkTheme: ReadonlyArray<AppContentTypesEnum> = [
  AppContentTypesEnum.INBOXES,
  AppContentTypesEnum.SETTINGS,
];

/*
 * Component.
 */

export const TopBarExpandedDarkThemeProvider: FC<TopBarExpandedDarkThemeProviderProps> = ({
  children,
  appContentType,
}) => {
  const maybeDarkTheme = useExpandedDarkTheme();

  const mergeTheme = () => {
    const fallbackTheme = lightTheme;
    return appsSupportingDarkTheme.includes(appContentType) ? maybeDarkTheme : fallbackTheme;
  };

  // Render the theme provider unconditionally to prevent our subtree from re-mounting.
  return <ThemeProvider theme={mergeTheme}>{children}</ThemeProvider>;
};
